<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 批量增加用户  -->
        <el-tab-pane>
          <span slot="label">
            {{ $t("logs.ldap15") }}
          </span>
           <div class="main">
            <el-alert
              :title="this.SHOW_RELATION1"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="lie">
            <table>
              <tbody>
               
                <tr>
                  <!-- 密码 -->

                  <td>{{ $t("logs.user_list6") }}:</td>
                  <td>
                    <el-input
                      type="password"
                      v-model="create_passwd1"
                      show-password
                    >
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("logs.user_list7") }}:</td>
                  <td>
                    <el-input
                      type="password"
                      v-model="create_passwd2"
                      show-password
                    >
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("logs.depart9") }}:</td>
                  <td>
                    <el-input type="text" v-model="create_maxspaces" clearable>
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("logs.user_list_manage7") }}:</td>
                  <td>
                    <el-input type="text" v-model="create_maxnetdisk" clearable>
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("logs.depart2") }}:</td>
                  <td>
                    <el-select v-model="create_depart_id">
                      <el-option
                        v-for="item in create_depart_id_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </td>
                </tr>
                 <tr>
                  <!-- 激活 -->
                  <td>{{ $t("logs.Policy_list9") }}:</td>
                  <td>
                    <el-checkbox-group v-model="bulk_active">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                  </td>
                </tr>
                 <tr>
                  <!-- 增加用户 -->
                  <td>{{ $t("logs.ldap15") }}:</td>
                  <td  style="width:50%">
                    <el-input
                   
  type="textarea"
  :autosize="{ minRows: 10, }"
  placeholder="请输入内容"
  v-model="bulkaddusers">
</el-input>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="display:flex;flex-direction:row">
                    <el-button type="primary" @click="tanSend_proxy()">{{
                      $t("logs.save_a")
                    }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
         <!-- 批量导入用户  -->
        <el-tab-pane>
          <span slot="label">
            {{ $t("logs.ldap16") }}
          </span>
            <div class="main">
            <el-alert
              :title="this.SHOW_RELATION1"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="lie">
            <table>
              <tbody>
               
                <tr>
                  <!-- 密码 -->

                  <td>{{ $t("logs.user_list6") }}:</td>
                  <td>
                    <el-input
                      type="password"
                      v-model="create_passwd1"
                      show-password
                    >
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("logs.user_list7") }}:</td>
                  <td>
                    <el-input
                      type="password"
                      v-model="create_passwd2"
                      show-password
                    >
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("logs.depart9") }}:</td>
                  <td>
                    <el-input type="text" v-model="create_maxspaces" clearable>
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("logs.user_list_manage7") }}:</td>
                  <td>
                    <el-input type="text" v-model="create_maxnetdisk" clearable>
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("logs.depart2") }}:</td>
                  <td>
                    <el-select v-model="create_depart_id">
                      <el-option
                        v-for="item in create_depart_id_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </td>
                </tr>
                 <tr>
                  <!-- 激活 -->
                  <td>{{ $t("logs.Policy_list9") }}:</td>
                  <td>
                    <el-checkbox-group v-model="bulk_active">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                  </td>
                </tr>
                 <tr>
                  <!-- 增加用户 -->
                  <td>{{ $t("logs.ldap16") }}:</td>
                  <td  style="height:44px;display:flex;align-items:center;justify-content: center;">
                   <input type="file" @change="inputFileChange" id="iupfile" ref="clearFile" accept=".excel,.xls,.xlsx" />
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="display:flex;flex-direction:row">
                    <el-button type="primary" @click="save_undown()">{{
                      $t("logs.create_user20")
                    }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {

      create_passwd1: "",
      create_passwd2: "",
      create_maxspaces: "",
      create_maxnetdisk: "",
      create_depart_id: "",
      create_depart_id_arr: [],
        bulk_active:true,
        bulkaddusers:'',
      SHOW_RELATION1: '',
       files: '',
    };
  },
  mounted() {
   
    this.getFileList_add();
   
  },
  methods: {
       // 白名单增加
        save_undown() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
                
                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "upload_patch");
                fd.append("sid", sid);
                fd.append("create_passwd1", 1);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/fmupgrade.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    console.log(res);
                    console.log(fd)

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                        // this.getFileList2();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                        // this.getFileList2();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        console.log(this.files)
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.del3')}`,
                        });
                        
                    }
                    // this.getFileList2();
                });
            }
        },
    inputFileChange(e) {

            this.files = e.target.files[0];
            // console.log(this.files);
        },
  
    
    // 网络代理加载
    getFileList_add() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "cfg_network",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList3();
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.enable_proxy =
              res.data.ret.ACTIVE == 0 ? (this.enable_proxy = false) : true;

            this.proxy_server = res.data.ret.PROXY_SERVER;

            this.proxy_port = res.data.ret.PROXY_PORT;
            this.proxy_user = res.data.ret.PROXY_USER;
            this.proxy_password = res.data.ret.PROXY_PASSWORD;

            // this.data_loadok_proxy = res.data.ret.ok
            // this.fileList6 = res.data.ret.datalist;
            // this.tls_typee = res.data.ret.q_tls_type

            //
          }
        });
    },
    // 网络代理保存
    tanSend_proxy() {
      // this.loading = true;
      // this.tanchu = false
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_netproxy",
        sid: sid,
        enable_proxy: this.enable_proxy == true ? 1 : 0,

        proxy_server: this.proxy_server,

        proxy_port: this.proxy_port,
        proxy_user: this.proxy_user,
        proxy_password: this.proxy_password,

        // data_loadok: this.data_loadok_proxy
      });
      this.$axios
        .post(
          "/api/adm/cgi/aspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList2();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
   
  },
};
</script>

<style lang="less" scoped>
// input 框高度
/deep/ .el-input__i nner {
  height: 30px;
}

/deep/ .el-alert__content {
  padding: 0;
}

/deep/ .el-input--suffix {
  width: 280px;
}

//  /deep/ .el-select .el-input__inner {
//     margin-left: -30px;
// }

// 1

.main p {
  padding-left: 10px;
  font-size: 14px;
  line-height: 28px;
}

// .main span {
//     padding-left: 20px;
// }

.el-button {
  padding: 6px;
}

.find2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //   height: 300px;
  padding-top: 30px;
  padding-left: 30px;
  width: 50%;
  margin-bottom: 20px;
}

.find2-1 {
  width: 100%;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  //   justify-content: center;

  div {
    padding: 0 5px;
  }
}

.find2-1 .find-text {
  font-size: 14px;
}

.find2-1 .el-row {
  margin-left: 140px;
}

// input 框高度
/deep/ .el-input__inner {
  height: 26px;
}

// 弹出框1
// 一行
.find {
  display: flex;
  //   flex: 1;
  overflow: auto;
  flex-direction: column;
  text-align: left;
  background: #f1f1f1;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
  padding: 40px 0;
  width: 80%;

  p {
    color: #999;
    font-size: 12px;
    text-align: center;
  }
}

.find1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px 0;
}

// 文字
.find-text {
  padding: 0 20px;
  font-size: 12px;
}

.el-input {
  // width: 20%;
  padding: 5px 10px 5px 0;
}

/deep/ .el-select {
  // padding-left: 30px;
  width: 222px;
}

// button  按钮
/deep/ .el-button {
  padding: 5px 10px;
  margin-left: 10px;
  font-size: 12px;
  background: #eceff4;
}

.pop-up {
  position: fixed;
  padding: 20px 0;
  width: 50%;
  //   height: 80%;
  top: 10%;
  left: 25%;
  z-index: 101;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  //   margin-left: -12.5%;
  //   margin-top: -14%;
}

.gray {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: black;
  opacity: 0.6;
  z-index: 100;
}

// input 框高度
/deep/ .el-input__inner {
  height: 30px;
}

.el-checkbox-group {
  display: flex;
}

.table span {
  font-size: 14px;
}

// th  改高度
/deep/ .el-table th {
  padding: 4px 0;
}

// td  改高度
/deep/ .el-table td {
  padding: 4px 0;
}

/deep/ .cell {
  text-align: center;
}

// 时间
.time {
  display: flex;
  flex-direction: column;
  border: 1px solid #dcdfe6;
  background: #f1f1f1;
  margin: 10px 0;
}

.time1 {
  display: flex;
  align-items: center;
  padding: 2px 0 2px 14px;
  font-size: 14px;
}

// 手动设置
.time-text1 {
  padding-left: 20px;
}

// 后台管理控制
.back {
  display: flex;
  font-size: 14px;
  line-height: 30px;
  align-items: center;
  padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
  margin: 0 10px;
}

.backText {
  text-align: right;
}

.backText1 {
  color: #999;
  font-size: 12px;
}

.back .el-input {
  width: 20%;
  padding: 0;
}

.time2 {
  display: flex;
  margin-left: 190px;
  margin-top: 10px;
}

.time2 .el-button {
  padding: 8px 24px;
  // margin: 10px ;
}

// License
.time3 {
  display: flex;
  align-items: center;
  // margin-left: 150px;
  font-size: 14px;
  padding: 4px 10px;
}

// selece
.selece1 {
  width: 130px;
}

// input 框
.back1 .input1 {
  width: 100px;
  margin: 0 10px;
}

// 单选框
.check1 {
  margin: 0 10px;
}

.backText2 {
  margin-left: 40px;
}

.backText3 {
  margin-left: 30px;
}

.back1 .input5-1 {
  width: 100px;
}

/deep/.el-input__icon {
  line-height: 30px;
  height: 30px;
}

// background: #424F63;
/deep/ .el-tabs__item .is-top {
  font-size: 12px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
  border-left: 0px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 20px;
}

// /deep/ .el-tabs__item.is-active {
//     //   color: #409eff;
//     background: #fff;
// }

// /deep/ .el-tabs__active-bar {
//     height: 0;
// }

// 弹框下的复选框
.el-checkbox:last-of-type {
  margin-right: 10px;
}

@import "../../css/table.less";

@import "../../css/lie_td.less";
</style>
